module.exports = __webpack_public_path__ + "fonts/fa-regular-400.c4f508e7.woff";